import { Outlet } from 'react-router-dom'
import { cn } from '../../lib/utils'

interface POSLayoutProps {
  className?: string
}

export const POSLayout = ({ className }: POSLayoutProps) => {
  return (
    <div className={cn("h-screen bg-white dark:bg-gray-900 flex flex-col", className)}>
      {/* Main Content - POSSystemNew will handle its own header */}
      <main className="flex-1 overflow-hidden bg-gray-50 dark:bg-gray-900">
        <Outlet />
      </main>
    </div>
  )
}